import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { API_GET, API_POST, API_PUT } from "../../../helpers/api";

import ComboBox from "../../../components/ComboBox";
import Checkbox from "../../../components/Checkbox";
import Button from "../../../components/Button";
import Pill from "../../../components/Pill";
import TitleValue from "../../../components/TitleValue";
import DataTable from "../../../components/DataTable";
import ModalConfirmation from "../../../components/Modal/ModalConfirmation";
import { setNotification } from "../../../helpers/notification";
import { convertAmountToFrontend } from "../../../helpers/convert";
import {
  getStationRequested,
  setStations,
} from "../../../redux/actions/stations";
import Loading from "../../../components/Loading";
import { Select, Textarea } from "../../../components/Inputs";
import { getOrganizationRequest } from "../../../redux/actions/organizations";
import { monthsAndResourceTypes } from "../../../constants/translations";
import OrganizationRegistrationModal from "../../../components/Modal/OrganizationRegistrationModal";

export default function OrganizationRegistration({ t }) {
  const dispatch = useDispatch();

  const selectedOrganization = useSelector(
    (state) => state.organizations.selectedOrganization
  );

  const updatedYekgOrganizationStatus = useRef(
    selectedOrganization?.yekgOrganizationStatus
  );
  // eslint-disable-next-line no-cond-assign
  if ([null, undefined].includes(updatedYekgOrganizationStatus.current)) {
    updatedYekgOrganizationStatus.current =
      selectedOrganization?.yekgOrganizationStatus;
  }
  const stations = useSelector((state) => state.stations.list);
  const stationsLoading = useSelector((state) => state.stations.loading);
  const [oSystemParticipationAgreement, setOSystemParticipationAgreement] =
    useState(false);

  const [oMarketParticipationAgreement, setOMarketParticipationAgreement] =
    useState(false);

  const [oParticipationFee, setOParticipationFee] = useState(false);
  const [description, setDescription] = useState(null);
  const [oManuelCheck, setOManuelCheck] = useState(false);
  const [oStatus, setOStatus] = useState(null);
  // Approve Modals
  const [takasbankApprove, setTakasbankApprove] = useState(false);
  // const [acceptPopup, setAcceptPopup] = useState(false);
  const [organizationApprove, setOrganizationApprove] = useState(false);
  const [organizationStatusApprove, setOrganizationStatusApprove] =
    useState(false);
  const [organizationStatusApproveFrom, setOrganizationStatusApproveFrom] =
    useState();
  const [changeControl, setChangeControl] = useState(false);
  const [takasBankLoading, setTakasBankLoading] = useState(false);
  const [completeRegistrationLoading, setCompleteRegistrationLoading] =
    useState(false);
  const [organizationStatusChangeLoading, setOrganizationStatusChangeLoading] =
    useState(false);
  const [isChangePassiveToActive, setIsPassiveToActive] = useState(false);
  const translations = monthsAndResourceTypes(t);
  // Data Table Stations columns
  const stationsListColumns = [
    {
      name: t("pages.default.organisationRegistration.table.stationId"),
      selector: "stationId",
      sortable: true,
    },
    {
      name: t("pages.default.organisationRegistration.table.stationName"),
      selector: "stationName",
      sortable: true,
    },
    {
      name: t("pages.default.organisationRegistration.table.stationLicenseNo"),
      selector: "stationLicenseNo",
      sortable: true,
    },
    {
      name: t("pages.default.organisationRegistration.table.installedPower"),
      selector: "installedPower",
      sortable: true,
      cell: (row) => {
        return convertAmountToFrontend(row.installedPower);
      },
    },
    {
      name: t("pages.default.organisationRegistration.table.sourceType"),
      selector: "resourceType",
      sortable: true,
      cell: (row) => {
        return translations[row.resourceType];
      },
    },
    {
      name: t(
        "pages.default.organisationRegistration.table.productionFacilityCommitment"
      ),
      selector: "productionFacilityCommitment",
      sortable: true,
      cell: (row, index) => {
        return (
          <Checkbox
            defaultChecked={row.productionFacilityCommitment}
            onChange={(e) => productionFacilityCommitmentChange(row, e)}
            label={t(
              "pages.default.organisationRegistration.table.productionFacilityCommitment"
            )}
            id={`or-station-checkbox-${index}`}
          />
        );
      },
    },
    {
      name: t("pages.default.organisationRegistration.table.status"),
      selector: "status",
      sortable: true,
      cell: (row) => {
        return row.registrationDate ? (
          <Pill
            label={t("pages.default.organisationRegistration.registered")}
            type="success"
          />
        ) : (
          <Pill
            label={t("pages.default.organisationRegistration.unRegistered")}
            type="important"
          />
        );
      },
    },
    {
      name: t("pages.default.organisationRegistration.table.registrationDate"),
      selector: "registrationDate",
      sortable: true,
      cell: (row) => {
        return row.registrationDate
          ? moment(row.registrationDate).format("DD.MM.YYYY HH:mm:ss")
          : "-";
      },
    },
  ];

  // Get stations for selected organization
  useEffect(() => {
    setDescription(null);
    if (selectedOrganization) {
      setOSystemParticipationAgreement(
        selectedOrganization.systemParticipationAgreement ? true : false
      );
      setOMarketParticipationAgreement(
        selectedOrganization.marketParticipationAgreement ? true : false
      );
      setOParticipationFee(
        selectedOrganization.participationFee ? true : false
      );
      setOManuelCheck(selectedOrganization.manuelCheck ? true : false);
      setOStatus(selectedOrganization.yekgOrganizationStatus ?? "PASSIVE");
      dispatch(getStationRequested(selectedOrganization.organizationId));
    }
  }, [selectedOrganization, dispatch]);

  const completeRegistrationButton = async () => {
    if (!changeControl) {
      setNotification(
        "error",
        t("pages.default.organisationRegistration.notifications.changeControl")
      );

      return false;
    }
    if (description === null) {
      setNotification(
        "error",
        t(
          "pages.default.organisationRegistration.notifications.desciriptionControl"
        )
      );
      return false;
    }

    setCompleteRegistrationLoading(true);
    try {
      if (selectedOrganization.registrationDate) {
        await API_PUT("organization/registration", {
          organizationId: selectedOrganization.organizationId,
          systemParticipationAgreement: oSystemParticipationAgreement,
          marketParticipationAgreement: oMarketParticipationAgreement,
          participationFee: oParticipationFee,
          description: description && description?.trim(),
          greenTariff: selectedOrganization.greenTariff,
          yekgOrganizationStatus: oStatus,
          manuelCheck: oManuelCheck,
          acceptPopup: selectedOrganization?.isRegistrationPopUpNeeded,
          registerStationRequests: stations.map((station) => {
            return {
              stationId: station.stationId,
              productionFacilityCommitment:
                station.productionFacilityCommitment,
            };
          }),
        });
        updatedYekgOrganizationStatus.current = oStatus;
        dispatch(getOrganizationRequest(selectedOrganization?.organizationId));
      } else {
        await API_POST("organization/registration", {
          organizationId: selectedOrganization?.organizationId,
          systemParticipationAgreement: oSystemParticipationAgreement,
          marketParticipationAgreement: oMarketParticipationAgreement,
          participationFee: oParticipationFee,
          description: description && description.trim(),
          greenTariff: selectedOrganization.greenTariff,
          yekgOrganizationStatus: oStatus,
          manuelCheck: oManuelCheck,
          acceptPopup: selectedOrganization?.isRegistrationPopUpNeeded,
          registerStationRequests: stations.map((station) => {
            return {
              stationId: station.stationId,
              productionFacilityCommitment:
                station.productionFacilityCommitment,
            };
          }),
        });
        updatedYekgOrganizationStatus.current = oStatus;
        dispatch(getOrganizationRequest(selectedOrganization?.organizationId));
      }

      if (
        oStatus === "ACTIVE" &&
        selectedOrganization.yekgOrganizationStatus === "PASSIVE"
      ) {
        setNotification(
          "success",
          `${selectedOrganization?.organizationId}${t(
            "pages.default.organisationRegistration.notifications.customTakasbankSuccess"
          )}`
        );
      } else if (
        selectedOrganization.marketParticipationAgreement !==
          oMarketParticipationAgreement &&
        oStatus === "ACTIVE"
      ) {
        setNotification(
          "success",
          t(
            "pages.default.organisationRegistration.notifications.registerSuccess"
          )
        );
      } else if (oStatus === "PASSIVE") {
        setNotification(
          "success",
          `${selectedOrganization?.organizationId}${t(
            "pages.default.organisationRegistration.notifications.accountStatusPasif"
          )}`
        );
      } else if (oStatus === "PARTIAL_PASSIVE") {
        setNotification(
          "success",
          `${selectedOrganization?.organizationId}${t(
            "pages.default.organisationRegistration.notifications.accountStatusPartialPasif"
          )}`
        );
      }

      setOrganizationApprove(false);
      setCompleteRegistrationLoading(false);
      setDescription(null);
      // getOrganization();
    } catch (error) {
      setCompleteRegistrationLoading(false);
      setNotification("error", error?.response?.data?.message);
      setNotification("error", error?.response?.data?.error);
      setOrganizationApprove(false);
    }
  };
  const statusChange = (e) => {
    const { value } = e.target;
    setOStatus(value);
    if (
      ["PASSIVE", "PARTIAL_PASSIVE"].includes(
        updatedYekgOrganizationStatus.current
      ) &&
      value === "ACTIVE"
    ) {
      setIsPassiveToActive(true);
    } else {
      setIsPassiveToActive(false);
    }
    setChangeControl(true);
  };
  const descriptionChange = (e) => {
    const { value } = e.target;

    if (value.length > 0) {
      setDescription(value);
      setChangeControl(true);
    } else {
      setDescription(null);
    }
  };
  const productionFacilityCommitmentChange = (row, e) => {
    let cStations = stations;
    let cStationIndex = cStations.findIndex(
      (station) => station.stationId === row.stationId
    );
    cStations[cStationIndex].productionFacilityCommitment = e.target.checked;
    dispatch(setStations(cStations));
    setChangeControl(true);
  };
  const systemParticipationAgreementChange = (e) => {
    if (oStatus === "ACTIVE" && !e.target.checked) {
      setOrganizationStatusApprove(true);
      setOrganizationStatusApproveFrom("participationAgreement");
    }
    setOSystemParticipationAgreement(e.target.checked);
    setChangeControl(true);
  };
  const marketParticipationAgreementChange = (e) => {
    setOMarketParticipationAgreement(e.target.checked);
    setChangeControl(true);
  };
  const participationFeeChange = (e) => {
    if (oStatus === "ACTIVE" && !e.target.checked) {
      setOrganizationStatusApprove(true);

      setOrganizationStatusApproveFrom("participationFee");
    }
    setOManuelCheck(true);
    setOParticipationFee(e.target.checked);
    setChangeControl(true);
  };
  // modal'den vazgeç denilince aksiyonlar eski haline alınır.
  const organizationStatusApproveToggle = () => {
    if (organizationStatusApproveFrom === "participationFee") {
      setOrganizationStatusApprove(false);
      setOParticipationFee(!oParticipationFee);
    } else {
      setOrganizationStatusApprove(false);
      setOSystemParticipationAgreement(!oSystemParticipationAgreement);
    }
  };
  // model'den onaylanınca hesap durumu passive'e alınır
  const organizationStatusChangeApprove = () => {
    setOrganizationStatusChangeLoading(true);
    setOStatus("PASSIVE");
    setOrganizationStatusApprove(false);
    setOrganizationStatusChangeLoading(false);
  };

  const takasBankControl = async () => {
    setTakasBankLoading(true);
    try {
      let res = await API_GET(
        `organization/registration/${selectedOrganization.organizationId}/takasbank-fee`
      );
      setNotification(
        "success",
        t(
          "pages.default.organisationRegistration.notifications.takasbankSuccess"
        )
      );
      setTakasbankApprove(false);
      setOManuelCheck(false);
      setOParticipationFee(res.data);
      setTakasBankLoading(false);
    } catch (error) {
      setTakasbankApprove(false);
      setTakasBankLoading(false);
      setNotification("error", error.response.data.message);
    }
  };
  return (
    <>
      <h5 className="km__u--text-has-emphasis">
        {t("pages.default.organisationRegistration.title")}
      </h5>
      <div className="km__p--organization-search-container">
        <div>
          <ComboBox t={t} />
          <div className="km__p--organization-infos">
            <TitleValue
              title={t("pages.default.organisationRegistration.info")}
              size="lg"
            />
            <TitleValue
              title={`${t("pages.default.organisationRegistration.name")}:`}
              value={
                selectedOrganization
                  ? selectedOrganization.organizationName
                  : "-"
              }
              size="lg"
              id={`or-info-name`}
            />
            <TitleValue
              title={`${t("pages.default.organisationRegistration.id")}:`}
              value={
                selectedOrganization ? selectedOrganization.organizationId : "-"
              }
              size="lg"
              id={`or-info-id`}
            />
            <TitleValue
              title={`${t(
                "pages.default.organisationRegistration.epysOrganizationStatus"
              )}:`}
              value={
                selectedOrganization
                  ? translations[selectedOrganization.organizationStatus]
                  : "-"
              }
              size="lg"
              id={`or-info-organizationStatus`}
            />
            <TitleValue
              title={`${t(
                "pages.default.organisationRegistration.yekgAccountStatus"
              )}:`}
              size="lg"
              id={`or-info-accountStatus`}
              value={
                selectedOrganization ? (
                  <Select
                    onChange={statusChange}
                    value={oStatus}
                    options={[
                      {
                        name: "-",
                        value: "",
                        disabled: true,
                      },
                      {
                        name: t(
                          "pages.default.organisationRegistration.active"
                        ),
                        value: "ACTIVE",
                        disabled: !oSystemParticipationAgreement ? true : false,
                      },
                      {
                        name: t(
                          "pages.default.organisationRegistration.passive"
                        ),
                        value: "PASSIVE",
                      },
                      {
                        name: t(
                          "pages.default.organisationRegistration.partialPassive"
                        ),
                        value: "PARTIAL_PASSIVE",
                      },
                    ]}
                    id={`or-info-accountStatus-select`}
                  />
                ) : (
                  "-"
                )
              }
            />
            <TitleValue
              title={`${t(
                "pages.default.organisationRegistration.epysLicenceType"
              )}:`}
              size="lg"
              value={
                selectedOrganization
                  ? translations[selectedOrganization.licenseType]
                  : "-"
              }
              id={`or-info-licenceType`}
            />
            <TitleValue
              title={`${t(
                "pages.default.organisationRegistration.yekgLicenceType"
              )}:`}
              size="lg"
              value={
                selectedOrganization
                  ? translations[selectedOrganization.yekgLicenseType]
                  : "-"
              }
              id={`or-info-yekgLicenceType`}
            />
            <TitleValue
              title={`${t(
                "pages.default.organisationRegistration.registrationDate"
              )}:`}
              size="lg"
              value={
                selectedOrganization
                  ? selectedOrganization.registrationDate
                    ? moment(selectedOrganization.registrationDate).format(
                        "DD MMMM YYYY"
                      )
                    : "-"
                  : "-"
              }
              id={`or-info-registrationDate`}
            />

            <TitleValue
              title={`${t(
                "pages.default.organisationRegistration.description"
              )}:`}
              size="lg"
              id={`or-info-description`}
              value={
                selectedOrganization ? (
                  <Textarea
                    onChange={descriptionChange}
                    id={`or-info-description-textarea`}
                    value={description ? description : ""}
                  />
                ) : (
                  "-"
                )
              }
            />
          </div>
          <div className="km__p--organization-checkboxes">
            <Checkbox
              label={t(
                "pages.default.organisationRegistration.systemParticipationAgreement"
              )}
              onChange={systemParticipationAgreementChange}
              checked={oSystemParticipationAgreement || false}
              disabled={!selectedOrganization}
              id={`or-checkbox-systemParticipationAgreement`}
            />
            <Checkbox
              label={t(
                "pages.default.organisationRegistration.marketParticipationAgreement"
              )}
              onChange={marketParticipationAgreementChange}
              checked={oMarketParticipationAgreement || false}
              disabled={!selectedOrganization || oStatus === "PASSIVE"}
              id={`or-checkbox-marketParticipationAgreement`}
            />
          </div>
          <div className="km__p--organization-actions">
            <Button
              label={t(
                "pages.default.organisationRegistration.completeRegistration"
              )}
              disabled={!selectedOrganization}
              onClick={() => setOrganizationApprove(true)}
              id={`or-button-complete`}
            />
          </div>
        </div>
      </div>

      {stationsLoading && <Loading text="İstasyonlar Yükleniyor" />}

      {!stationsLoading && stations.length > 0 && selectedOrganization && (
        <div className="km__p__organization-stations-container">
          <DataTable
            rowKey="stationId"
            columns={stationsListColumns}
            data={stations}
            pagination
            paginationPerPage={25}
          />
        </div>
      )}
      {!stationsLoading && stations.length === 0 && selectedOrganization && (
        <div className="km__p__organization-stations-container">
          {t("pages.default.organisationRegistration.stationNotFound")}
        </div>
      )}
      <ModalConfirmation
        isOpen={takasbankApprove}
        toggle={() => setTakasbankApprove(!takasbankApprove)}
        header={t(
          "pages.default.organisationRegistration.modals.takasbank.title"
        )}
        body={t(
          "pages.default.organisationRegistration.modals.takasbank.description"
        )}
        approve={() => takasBankControl()}
        loading={takasBankLoading}
      />

      {isChangePassiveToActive &&
      selectedOrganization?.isRegistrationPopUpNeeded ? (
        <OrganizationRegistrationModal
          isOpen={organizationApprove}
          toggle={() => setOrganizationApprove(!organizationApprove)}
          organizationId={selectedOrganization?.organizationId}
          transactionDate={moment().format("MM-DD-YYYY HH:mm:ss")}
          PassiveDate={moment().format("YYYY")}
          approve={() => completeRegistrationButton()}
          loading={completeRegistrationLoading}
        />
      ) : (
        <ModalConfirmation
          isOpen={organizationApprove}
          toggle={() => setOrganizationApprove(!organizationApprove)}
          header={t(
            "pages.default.organisationRegistration.modals.completeRegistration.title"
          )}
          body={t(
            "pages.default.organisationRegistration.modals.completeRegistration.description"
          )}
          approve={() => completeRegistrationButton()}
          loading={completeRegistrationLoading}
        />
      )}

      <ModalConfirmation
        isOpen={organizationStatusApprove}
        toggle={() => organizationStatusApproveToggle()}
        header={t(
          "pages.default.organisationRegistration.modals.accountStatusChange.title"
        )}
        body={t(
          "pages.default.organisationRegistration.modals.accountStatusChange.description"
        )}
        approve={() => organizationStatusChangeApprove()}
        loading={organizationStatusChangeLoading}
      />
    </>
  );
}
